export default "__VITE_ASSET__BOVfHU4L__"